import React, { Component } from "react";

class AccessUser extends Component {
    constructor(props) {
        super(props);
    }

    onPasswordNextAccessChange = (event) => {
        let value = event.target.checked;
        let prop = event.target.dataset.userinfo;

        this.props.updateInformacionUsuario(prop, value);
    }

    render() {
        return (
            <div className="checkbox-container">
                <input type="checkbox" id="changePass" data-userinfo="Cambio_Clave"
                    checked={this.props.cambioClave}
                    onClick={this.onPasswordNextAccessChange} />
                <label htmlFor="changePass">Debe cambiar la clave en el próximo acceso <span className="optional">(opcional)</span></label>
            </div>
        );
    }
}

export default AccessUser;